import { render, staticRenderFns } from "./closedInvoiceList.vue?vue&type=template&id=b6c473f6&scoped=true&"
import script from "./closedInvoiceList.vue?vue&type=script&lang=js&"
export * from "./closedInvoiceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c473f6",
  null
  
)

export default component.exports